var API = "https://approval-dashboard.asikhwal.workers.dev";
var COMPANY = "company_RBFC";

function loadRejected() {
  fetch(API + "/get-rejected?company=" + COMPANY)
    .then(function(res) { return res.json(); })
    .then(function(data) { renderRejected(data); })
    .catch(function() {
      document.getElementById("orders").innerHTML = "Error loading orders";
    });
}

function renderRejected(data) {
  var container = document.getElementById("orders");
  container.innerHTML = "";

  if (!data || data.length === 0) {
    container.innerHTML = "No rejected orders";
    return;
  }

  data.forEach(function(item) {
    var o = item.node;

    var div = document.createElement("div");

    div.innerHTML =
      '<hr>' +
      '<strong>' + o.name + '</strong><br>' +
      'Customer: ' + (o.customer ? o.customer.email : '') + '<br>' +
      'Total: ' + o.totalPrice + '<br>' +
      '<span style="color:red;">Rejected</span>';

    container.appendChild(div);
  });
}

loadRejected();